import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { COUNTY_COORDS, KENYA_CENTER } from "@/data/constants";

export const pinIcon = L.divIcon({
  className: "",
  html: `<div style="transform:translate(-50%,-100%);">
    <svg width="34" height="44" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 0C5.37 0 0 5.37 0 12c0 8.25 12 20 12 20s12-11.75 12-20C24 5.37 18.63 0 12 0z" fill="#2C3830"/>
      <circle cx="12" cy="12" r="5" fill="#D4A373"/>
    </svg></div>`,
  iconSize: [0, 0],
  iconAnchor: [0, 0],
});

export const MapView = ({ lat, lng, county, label }) => {
  const fallback = COUNTY_COORDS[county] || KENYA_CENTER;
  const hasPin = lat != null && lng != null;
  const pos = hasPin ? [lat, lng] : fallback;

  return (
    <div data-testid="map-view" className="relative isolate z-0 h-56 w-full overflow-hidden rounded-xl border border-border/60">
      <MapContainer
        center={pos}
        zoom={hasPin ? 15 : 12}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={pos} icon={pinIcon}>
          {label && <Popup>{label}</Popup>}
        </Marker>
      </MapContainer>
    </div>
  );
};
